// PENDING: PENDING-SECURITY-INFO
// Sample security details for the story SQL dialog's strip. No endpoint returns the bound parameters,
// the row-level security state or the masked columns yet. Neutral, made-up content only.

export interface StorySqlSampleParameter {
  name: string;
  value: string;
}

export const STORY_SQL_SAMPLE_PARAMETERS: readonly StorySqlSampleParameter[] = [
  { name: "p_start", value: "2000-01-01" },
  { name: "p_end", value: "2000-12-31" },
  { name: "p_group", value: "sample" },
];

/** How many columns the sample strip says were masked and left out. */
export const STORY_SQL_SAMPLE_MASKED_COLUMN_COUNT = 2;
